import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { useDialog } from '../../shared/context';
import { Button, Box } from '@mui/material';
import SectorConsultLayout from '../layout/sectorRegistre/sectorConsultLayout';
import SectorRegistreLayout from '../layout/sectorRegistre/sectorRegistreLayout';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const SectorRegistreDialog = ({ handleCancel }) => {
  const sectorUserDialog = useDialog('sectorRegistreDialog');
  const [getComponent, setComponent] = useState('consult');
  const [getTitle, setTitle] = useState('Consultar Setores');
  const [getItem, setItem] = useState({});

  const handleChangeComponent = (title, component, item = {}) => {
    setComponent(component);
    setTitle(title);
    setItem(item);
  };

  return (
    <Dialog
      open={sectorUserDialog.isDialogOpen()}
      TransitionComponent={Transition}
      keepMounted
      onClose={sectorUserDialog.closeDialog}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="xl"
      fullWidth
    >
      <DialogTitle sx={{ fontSize: '2em' }}>{getTitle}</DialogTitle>
      <DialogContent>
        <Box>
          {getComponent === 'consult' ? (
            <SectorConsultLayout handleChangeComponent={handleChangeComponent} />
          ) : (
            <SectorRegistreLayout
              handleChangeComponent={handleChangeComponent}
              getComponent={getComponent}
              item={getItem}
            />
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleCancel}>
          fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SectorRegistreDialog;
